function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M.82 2a1 1 0 011-1h2.7A2 2 0 016.47 2.561L7.02 5h21.602a2 2 0 011.967 2.358l-1.337 7.358A4 4 0 0125.316 18H9.945l.148.659A3 3 0 0013.02 21h14.8a1 1 0 110 2h-14.8a5 5 0 01-4.878-3.902L4.52 3h-2.7a1 1 0 01-1-1zm8.675 14h15.821a2 2 0 001.968-1.642L28.622 7H7.47l2.025 9zM14.82 27.5a3.5 3.5 0 11-7 0 3.5 3.5 0 017 0zm-2 0a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM28.82 27.5a3.5 3.5 0 11-7 0 3.5 3.5 0 017 0zm-2 0a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z",
  fill: "currentColor"
})));